class UnitSwitch extends HTMLElement {
  constructor() {
    super();

    this.milliliterEls = document.querySelectorAll(".milliliters");
    this.ounceEls = document.querySelectorAll(".ounces");

    this.attachShadow({ mode: "open" });

    // Create initial HTML structure
    this.shadowRoot.innerHTML = `
      <style>
        .switch {
          position: relative;
          display: inline-block;
          width: 30px;
          height: 17px;
          line-height: 1;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          -webkit-transition: 0.4s;
          transition: 0.4s;
          border-radius: 17px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 11px;
          width: 11px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          -webkit-transition: 0.4s;
          transition: 0.4s;
          border-radius: 50%;
        }

        .switch input:checked + .slider {
          background-color: var(--color-monin-brown);
        }

        .switch input:focus + .slider {
          box-shadow: 0 0 1px var(--color-monin-brown);
        }

        .switch input:checked + .slider:before {
          -webkit-transform: translateX(13px);
          -ms-transform: translateX(13px);
          transform: translateX(13px);
        }

        .measurement-label {
          font-size: 12px;
          display: inline-block;
        }
          
        .visually-hidden {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border: 0;
    } 
      </style>
      <div class="switch-container">
        <span class="measurement-label">oz</span>
        <label class="switch">
          <input type="checkbox" id="measurements" name="measurements">
          <span class="slider round"></span>
          <span class="visually-hidden">Toggle Measurements</span>
        </label>
        <span class="measurement-label">mL</span>
      </div>
    `;

    // Get references to elements
    this.checkbox = this.shadowRoot.querySelector("input");

    // Add event listener
    this.checkbox.addEventListener("change", (event) => {
      const unit = event.target.checked ? "mL" : "oz";
      this.handleChange(unit);
    });

    // Update checkbox on load
    if (localStorage.getItem("recipeUnit")) {
      this.handleChange(localStorage.getItem("recipeUnit"));
      this.checkbox.checked = localStorage.getItem("recipeUnit") === "mL";
    }
  }

  handleChange(unit) {
    localStorage.setItem("recipeUnit", unit);

    if (unit === "oz") {
      this.ounceEls.forEach((el) => {
        el.classList.remove("hide");
      });

      this.milliliterEls.forEach((el) => {
        el.classList.add("hide");
      });
    } else {
      this.ounceEls.forEach((el) => {
        el.classList.add("hide");
      });

      this.milliliterEls.forEach((el) => {
        el.classList.remove("hide");
      });
    }
  }
}

// Register the custom element
customElements.define("unit-switch", UnitSwitch);
